import addAgendaItemsMutator from '../mutators/addAgendaItemsMutator';
import setAgendaViewMarkers from './setAgendaViewMarkers';
import { AgendaItem } from 'mini-agenda';

/**
 * FUnction called when we want to add items in the list of agenda Items
 * @param agendaItems
 * @param shouldAddToTop
 */
export default function addAgendaItems(agendaItems: AgendaItem[], shouldAddToTop: boolean) {
    addAgendaItemsMutator(agendaItems, shouldAddToTop);
    setAgendaViewMarkers();
}
